import request from '@/utils/request';


export function getCenterApplyInfos(params) {
  return request({
    url: '/api/insure/index/center/orderInfos',
    method: 'get',
    params,
  });
}
export default {getCenterApplyInfos};
